import React from 'react';
import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { LineContent, LineContainer, BackgroundGradient, animationLine } from './commonStyles';

const CardPreview = ({ device, isStatisticsByPosting, onSharedDesempeno }) => {
  return (
    <Container className={`skeleton-card-preview-${device}`} isStatisticsByPosting={isStatisticsByPosting}>
      <div />
      <div className='skeleton-card-preview-info-area'>
        {device === 'desktop' && (
          <>
            <LineContainer marginBottom='16px'>
              <LineContent width='93px' />
              <LineContent width='50px' />
            </LineContainer>
            <LineContent width='100%' marginBottom='12px' />
            <LineContent width='190px' marginBottom='19px' />
            <CardPreviewBottomArea>
              <div>
                <LineContent width='129px' marginBottom='9px' />
                <LineContent width='129px' marginBottom='9px' />
                <LineContent width='129px' marginBottom='29px' />
                <LineContent width='129px' />
              </div>
              {!onSharedDesempeno && <div className='skeleton-card-preview-quality' />}
            </CardPreviewBottomArea>
          </>
        )}
        {device === 'tablet' && (
          <>
            <LineContainer marginBottom='11px'>
              <LineContent width='50px' />
              <LineContent width='50px' />
            </LineContainer>
            <LineContent width='379px' marginBottom='11px' />
            <LineContent width='182px' marginBottom='24px' />
            <LineContainer marginBottom='8px' width='357px'>
              <LineContent width='115px' />
              <LineContent width='116px' />
            </LineContainer>
            <LineContent width='125px' />
          </>
        )}
        {device === 'mobile' && (
          <>
            <LineContainer marginBottom='8px'>
              <LineContent width='84px' />
              <LineContent width='60px' />
            </LineContainer>
            <LineContent width='196px' marginBottom='8px' />
            <LineContent width='57px' marginBottom='8px' />
            <LineContent width='41px' marginBottom='8px' />
            <LineContent width='131px' />
          </>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div`
  width: ${({ isStatisticsByPosting }) => (isStatisticsByPosting ? 380 : 290)}px;
  height: 446px;
  background-color: white;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.08);
  margin-right: 39px;
  border-radius: 8px;
  border: 1px solid ${select('grayMedium')};
  > div {
    :first-of-type {
      width: 100%;
      height: 151px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      background-color: ${select('grayMedium')};
    }
    &.skeleton-card-preview-info-area {
      display: flex;
      flex-direction: column;
      padding: 20px 24px 64px 18px;
      flex: 1;
    }
  }
  &.skeleton-card-preview-tablet {
    width: 100%;
    height: 188px;
    box-shadow: none;
    margin: 0 0 ${({ isStatisticsByPosting }) => (isStatisticsByPosting ? 0 : 31)}px 0;
    display: flex;
    > div {
      :first-of-type {
        width: 189px;
        height: 100%;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border-top-right-radius: 0;
        background-color: ${select('grayMedium')};
      }
      &.skeleton-card-preview-info-area {
        display: flex;
        flex-direction: column;
        padding: 18px;
      }
    }
  }
  &.skeleton-card-preview-mobile {
    width: 100%;
    height: 143px;
    box-shadow: none;
    margin: 0 0 ${({ isStatisticsByPosting }) => (isStatisticsByPosting ? 0 : 25)}px 0;
    display: flex;
    align-items: center;
    padding-left: 17px;
    justify-content: space-between;
    > div {
      :first-of-type {
        width: 82px;
        height: 82px;
        border-radius: 4px;
        background-color: ${select('grayMedium')};
      }
      &.skeleton-card-preview-info-area {
        display: flex;
        flex-direction: column;
        padding: 18px;
      }
    }
  }
`;

const CardPreviewBottomArea = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  > div {
    &.skeleton-card-preview-quality {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      ${BackgroundGradient};
      ${animationLine};
    }
  }
`;

export default CardPreview;
